import React from 'react';
import { Alert, Button, FloatingLabel, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { authApi } from '@reducers/auth';
import { skipToken } from '@reduxjs/toolkit/query';

const schema = Yup.object({
  login: Yup.string().required('This field is required.'),
  password: Yup.string().required('This field is required.'),
});

const LoginForm = () => {
  const { formLogin, token } = useSelector((state) => state.auth);
  const getUser = authApi.useGetUserQuery(token ? {} : skipToken);
  const [login, { isLoading }] = authApi.useLoginMutation();
  const onSubmit = async (values, actions) => {
    login(values)
      .unwrap()
      .catch((response) => actions.setFieldError('auth', response.data));
  };

  if (getUser.isLoading) {
    return <DefaultSpinnerCenter />;
  }

  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      initialValues={{
        login: formLogin || '',
        password: '',
      }}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <Form onSubmit={handleSubmit}>
          <FloatingLabel
            controlId="floatingLogin"
            label="Login"
            className="mb-1 mt-3"
          >
            <Form.Control
              type="text"
              placeholder="Login"
              name="login"
              value={values.login}
              onChange={handleChange}
              onBlur={handleBlur}
              isValid={touched.login && !errors.login}
              isInvalid={touched.login && errors.login}
            />
            <Form.Control.Feedback type="invalid">
              {errors.login}
            </Form.Control.Feedback>
          </FloatingLabel>
          <FloatingLabel
            controlId="floatingPassword"
            label="Password"
            className="mb-1"
          >
            <Form.Control
              type="password"
              placeholder="Password"
              name="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              isValid={touched.password && !errors.password}
              isInvalid={touched.password && errors.password}
            />
            <Form.Control.Feedback type="invalid">
              {errors.password}
            </Form.Control.Feedback>
          </FloatingLabel>
          {errors.auth ? (
            <Alert className="p-1" variant="danger">
              {errors.auth}
            </Alert>
          ) : null}
          <Button
            type="submit"
            className="w-100 mb-1"
            variant="didxl"
            disabled={isLoading}
          >
            Sign in
          </Button>
          <Button
            as={Link}
            to="/password/reset"
            className="w-100"
            variant="secondary"
          >
            Reset password
          </Button>
        </Form>
      )}
    </Formik>
  );
};
export default LoginForm;
